import { Box, Stack, Typography } from '@mui/joy';
import useEvents from '../../../hooks/useEvents';
import { EventHighlightCard } from './EventHighlightCard';

interface UpcomingEventsProps {
  onlyShowFirstOnMobile?: boolean;
}

export const UpcomingEvents = (props: UpcomingEventsProps) => {
  const { onlyShowFirstOnMobile } = props;
  const eventsQuery = useEvents();

  const events = eventsQuery.data || [];

  const futureEvents = events.filter(
    (event) => new Date(event.dateStart) > new Date()
  );
  const sortedFutureEvents = futureEvents.sort(
    (a, b) => new Date(a.dateStart).getTime() - new Date(b.dateStart).getTime()
  );

  return (
    <Stack gap={1}>
      <Typography level="title-lg">{'Aankomende evenementen'}</Typography>
      {sortedFutureEvents.map((event, index) => {
        let renderOnMobile = true;
        if (onlyShowFirstOnMobile) {
          renderOnMobile = index === 0;
        }
        return (
          <Box
            key={event._id}
            sx={{
              display: {
                xs: renderOnMobile ? 'block' : 'none',
                lg: 'block',
              },
            }}
          >
            <EventHighlightCard
              date={new Date(event.dateStart) || ''}
              imageUrl={event.imageUrl || ''}
              location={event.location}
              title={event.title}
              href={`/events/${event._id}`}
              compact={true}
            />
          </Box>
        );
      })}
    </Stack>
  );
};
